<template>
  <div class="h5-live-calendar">
    <my-calendar
      class="calendar-wrap"
      :markDate="markDate"
      @clickDay="handleClickDay"
      @changeMonth="handleChangeMonth"
      @showAllData="showAllData"
    ></my-calendar>
    <div class="list-wrap">
      <ul
        v-if="showDataList.length"
        class="live-list-wrap"
        @scroll="handleScroll"
      >
        <li
          class="live-item"
          v-for="item in showDataList"
          :key="item.lesson_id"
        >
          <div class="time-axis" :class="{ 'can-join': item.status !== 1 }">
            <span
              v-if="showAll"
              v-html="liveInThisYear(item)"
              style="margin-right: 7px"
            ></span>
            <span>{{
              moment(item.live_start_time * 1000).format("HH:mm")
            }}</span>
          </div>
          <div class="live-card" @click="goLiveRoom(item)">
            <img
              class="cover"
              :src="item.cover_url + '?imageView2/0/w/320'"
              alt=""
            />
            <div class="live-info">
              <p class="name">
                {{ item.lesson_name }}
              </p>
              <div>
                <p class="course-name">
                  所属课程：<span>{{ item.course_name }}</span>
                </p>
                <p class="unit-name">
                  所属单元：<span>{{ item.unit_name }}</span>
                </p>
              </div>
            </div>
            <div class="operate-wrap">
              <span class="status" v-if="item.status === 1">{{
                item.first_join_time
                  ? `提前${item.first_join_time}分钟可进入教室`
                  : "未开始"
              }}</span>
              <button v-else class="join-live-btn">进入教室</button>
            </div>
          </div>
        </li>
      </ul>
      <el-empty v-else description="暂无内容" :image="emptyImageUrl"></el-empty>
    </div>
  </div>
</template>

<script>
import liveCalendar from "./mixins/live-calendar.js";
import { getCdnUrl } from "@saas/components/src";
export default {
  mixins: [liveCalendar],
  data() {
    return {
      emptyImageUrl: getCdnUrl("/cdn/static/images/empty.png"),
    };
  },
};
</script>

<style lang="scss" scoped>
$h5-live-cover-height: 1.55rem;
.h5-live-calendar {
  padding-top: 1.39rem;
  .calendar-wrap {
    margin: 0 auto;
  }
  .live-list-wrap {
    padding-left: 0.77rem;
    padding-bottom: 0.4rem;
  }
  .live-item {
  }
  .time-axis {
    margin-top: 0.32rem;
    font-weight: 400;
    font-size: 0.37rem;
    color: var(--text-secondary, #747573);
    line-height: 0.64rem;
    position: relative;
    margin-bottom: 0.11rem;
    &.can-join {
      font-weight: 500;
      font-size: 0.37rem;
      color: var(--text-primary, #333333);
      line-height: 0.64rem;
      &::after {
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      }
    }
    &::after {
      position: absolute;
      left: -0.42rem;
      top: 50%;
      transform: translateY(-50%);
      display: block;
      content: "";
      width: 0.21rem;
      height: 0.21rem;
      background: var(--text-tertiary, #c9cdd4);
      border-radius: 50%;
    }
  }
  .live-card {
    display: flex;
    align-items: center;
    width: 8.91rem;
    height: 2.08rem;
    background: var(--card-bg, #ffffff);
    border-radius: 0.21rem;
    padding: 0 0.27rem;
    position: relative;
    &::after {
      position: absolute;
      left: -0.31rem;
      top: 0;
      display: block;
      content: "";
      width: 0.03rem;
      height: 2.08rem;
      background: var(--border-color, #e5e6eb);
    }
    .cover {
      width: 2.75rem;
      height: $h5-live-cover-height;
      object-fit: cover;
      border-radius: 0.16rem;
      margin-right: 0.16rem;
    }
    .live-info {
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: $h5-live-cover-height;
      .name {
        font-weight: 500;
        font-size: 0.32rem;
        color: var(--text-primary, #0d1400);
        line-height: 0.45rem;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .course-name,
      .unit-name {
        font-weight: 400;
        font-size: 0.29rem;
        color: var(--text-secondary, #747573);
        line-height: 0.43rem;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .operate-wrap {
      width: 1.65rem;
      margin-left: 0.16rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .status {
        font-weight: 400;
        font-size: 0.32rem;
        color: var(--text-tertiary, #858687);
        line-height: 0.4rem;
      }
      .join-live-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.57rem;
        height: 0.69rem;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 0.16rem;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.43rem;
      }
    }
  }
}
</style>
